import { configureStore } from '@reduxjs/toolkit';
import moment from 'moment';
import cookie from 'react-cookies';

import createRootReducer from './reducers';
import { loggedIn } from './actions';

function restorePreviousState(store: any): void {
  const token = cookie.load('token');
  if (token) {
    const expiredDate = moment(token.created).add(token.ttl, 'seconds');
    if (expiredDate > moment()) {
      store.dispatch(loggedIn(token.email, token));
    } else {
      cookie.remove('token');
    }
  }
}

export default function configureReduxStore() {
  // Note: only Redux >= 3.1.0 supports passing enhancer as third argument.
  // See https://github.com/reactjs/redux/releases/tag/v3.1.0
  const store = configureStore({
    reducer: createRootReducer(),
  });
  restorePreviousState(store);

  // // Hot reload reducers (requires Webpack or Browserify HMR to be enabled)
  // if ((module as any).hot) {
  //   (module as any).hot.accept('./reducers', () => store.replaceReducer(createRootReducer()));
  // }
  return store;
}
